
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success-stories",
      function () {
        return require("private-next-pages/success-stories.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/success-stories"])
      });
    }
  